import { combineReducers } from 'redux';
import modal from 'store/reducers/newVersionModal/modal';

export default combineReducers({
  modal
});